var searchSuggester = {
	inputPlaceholder: "Cerca",
	clearSearchTerm: "Cancella termine di ricerca",
	noResults: "Nessun risultato trovato",
	allSearchResults: "Tutti i risultati di ricerca",
	validationErrors: {
		searchTerm: {
			invalidInput: "Valore non valido"
		}
	}
};
var searchSuggesterTranslationsIt = {
	searchSuggester: searchSuggester
};

export { searchSuggesterTranslationsIt as default, searchSuggester };
